import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from "../../../auth/auth.service";
import { Router } from "@angular/router";
import { Roles } from '../../../auth/roles.enum';
import { environment } from '../../../../environments/environment';
import { Area } from '../../constants/area';
import { JwtUtils } from '../../../auth/utilities/jwtUtils';
import { LocalStorageKeys } from '../../constants/localStorageKeys.enum';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent implements OnInit {

  public CurrentUserName: string;
  public appVersion: string = localStorage.getItem(LocalStorageKeys.APP_VERSION);

  public get userRoles(): string {
    return JwtUtils.getRoleNames().join(', ');
  }

  constructor(
    private authService: AuthService,
    private route: Router,
    private httpClient: HttpClient
  ) {
  }

  ngOnInit() {
    this.CurrentUserName = this.authService.currentUserName;
  }

  public showDevMenu() {
    return JwtUtils.hasRoleByName(Roles.Developer);
  }

  public testUnauthenticated() {
    this.httpClient.get(`${environment.dotNetApiUrl}/${Area.test}/testAuth/testUnauthenticated`)
      .subscribe(() => {

      })
  }

  logout() {
    this.authService.logout();
    this.route.navigateByUrl('/auth/logged-out');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/user-menu/user-menu.component.ts